<template>
<div class="container mt-5">
        <div class="h1 text-center"><strong>結帳</strong></div>
        <div class="row mt-3">
            <div class="col-12 col-md">
                <div class="alert alert-success alert-rounded text-center" role="alert">輸入訂單資料</div>
            </div>
        </div>
        <div class="row justify-content-center mt-4">
            <div class="col-md-8">
                <div class="accordion" id="accordionExample">
                    <div class="card card-bottom">
                        <div class="card-header  d-flex justify-content-between" id="headingOne">
                            <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne"
                                aria-expanded="true" aria-controls="collapseOne">
                                顯示購物車
                            </button>
                            <div class="h3 d-inline-block mt-2">
                                <strong>$ 20000</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th width="80"></th>
                                <th width="25%"> 商品名稱</th>
                                <th class="text-center">數量</th>
                                <th class="text-center" width="25%">小計</th>
                                <th width="20"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="align-middle">
                                    <div class="card p-1 card-bottom">
                                        <img :src="'./files/images/p5-2.jpg'" alt="..." width="80px;">
                                    </div>
                                </td>
                                <td class="align-middle">祈福光明燈祈福光明燈</td>
                                <td class="align-middle text-center">10</td>
                                <td class="align-middle text-center">$20000</td>
                                <td class="align-middle"><a href="#removeModal" class="text-dark" data-price="999"
                                        data-title="祈福光明燈" data-toggle="modal" data-target="#removeModal"><i
                                            class="far fa-trash-alt mr-3"></i></a></td>
                            </tr>
                            <tr style="border-top: 1px solid #dee2e6;">
                                <td class="text-right" colspan="3"><strong>合計</strong></td>
                                <td class="text-center"><strong>$ 20000</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="card text-center my-5 border-0">
                    <div class="card-header border-0">
                        <div class="h3 mt-1"> 訂購人資訊 </div>
                    </div>
                    <form class="needs-validation" style="background-color: #f9f9f9 !important" novalidate>
                        <div class="form-row text-left mt-3">
                            <div class="form-group col-md-6">
                                <label for="name">姓名</label>
                                <input type="text" class="form-control " id="name" placeholder="姓名" required>
                                <div class="invalid-feedback">請填寫姓名</div>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="phone">手機</label>
                                <input type="phone" class="form-control" id="phone" placeholder="手機號碼" required>
                                <div class="invalid-feedback">請填寫Email</div>
                            </div>
                        </div>
                        <div class="form-row text-left">
                            <div class="form-group col-md-4">
                                <label for="zone">住址</label>
                                <select name="" id="zone" class="form-control">
                                    <option value="">台北市</option>
                                    <option value="">台中市</option>
                                    <option value="">高雄市</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="zone">地區</label>
                                <select name="" id="zone" class="form-control">
                                    <option value="">信義區</option>
                                    <option value="">中區</option>
                                    <option value="">北區</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="postal-code">郵遞區號</label>
                                <input type="text" class="form-control" id="postal-code" placeholder="" required>
                            </div>
                        </div>
                        <div class="form-row">
                            <label for="address">地址</label>
                            <input type="text" class="form-control" id="mail" placeholder="一路123號" required>
                        </div>
                        <div class="card-header border-0 mt-3">
                            <div class="h3 mt-1"> 選擇付款方式</div>
                        </div>
                        <div class="row" style="padding: 0.75rem 1.25rem;">
                            <div class="form-check col-md-6">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                    value="option1" checked>
                                <label class="form-check-label" for="exampleRadios1">
                                    信用卡
                                </label>
                                <div style="width: 50%; margin:0 auto;">
                                    <img :src="'./files/images/card.png'" alt="">
                                </div>
                            </div>
                            <div class="form-check col-md-6">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2"
                                    value="option2">
                                <label class="form-check-label" for="exampleRadios2">
                                    A T M
                                </label>
                                <div style="width: 50%; margin:0 auto;">
                                    <img :src="'./files/images/atm.png'" alt="">
                                </div>
                            </div>
                        </div>

                        <div class="mt-3 d-flex justify-content-end">
                            <a :href="base_url+'/'" class="btn btn-secondary mr-2">繼續選購</a>
                            <a :href="base_url+'/cmple'" type="submit" class="btn btn-primary">確認付款</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                base_url
            }
        },
    }
</script>

<style scoped>
    .homebtn {
        border: solid;
        padding: 10px;
    }
</style>>